import { render, staticRenderFns } from "./ListSoko.vue?vue&type=template&id=380d6eac&"
import script from "./ListSoko.vue?vue&type=script&lang=ts&"
export * from "./ListSoko.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports